<template lang="pug">
app-button(
  v-bind="extendAttrs"
  @click="openDialog"
)
  p {{ label }}
  portal(to="event-teams-requests.content" v-slot="{ close }")
    teams-requests(
      :event-id="eventId"
      :item-container="{ class: 'redesignControlsBackgroundAlternative' }"
      :item-childs="{ class: 'redesignControlsBackground' }"
      @refresh="$emit('refresh');"
      @edit-team="toRequestRoute($event, close)"
    )

</template>

<script>
import TeamsRequests from '@/modules/Team/components/EventTeamRegister/TeamsRequests.vue';

export default {
  components: {
    TeamsRequests,
  },
  props: {
    eventId: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const { $attrs, $vnode } = this;
      // Костыль, покуда vue 2 не умеет в $attrs классы забирать
      const classList = $vnode?.data?.staticClass || '';
      return {
        class: classList || [
          'body-1',
          'pa-0',
          'fit-content-width',
          'redesignPrimaryDarken--text',
          'weight-500',
        ],
        color: 'transparent',
        text: true,
        opacity: 1,
        height: '24px',
        label: 'Список моих заявок',
        ...$attrs,
      };
    },
  },
  methods: {
    openDialog() {
      this.$dialogs.portal({
        attrs: {
          'max-width': 1000,
          hideActions: true,
          title: 'Команды заявок',
          inputValue: 'event-teams-requests',
          'card-attrs': {
            class: '',
          },
        },
      });
    },
    toRequestRoute(request, closeFn) {
      const params = {
        id: request.event_id,
        requestId: request.id,
      };
      this.$router.push({ name: 'event-team-register-request', params });
      closeFn();
    },
  },
};
</script>
